import { Session } from "next-auth";

/*
↓のようにしてsession情報を取得する
const {session,sessionStatus} = useSyncExternalStore(sessionStore.subscribe, sessionStore.getSnapshot,sessionStore.getServerSnapshot);
*/

export type SessionStatus = "authenticated" | "loading" | "unauthenticated";

type SessionData = {
  sessionStatus: SessionStatus;
  session: Session | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateSession?: (data: any) => Promise<Session | null>;
};

let sessionData: SessionData = {
  sessionStatus: "loading",
  session: null,
  updateSession: undefined,
};
const defaultSessionData = sessionData;
let listeners: (() => void)[] = [];

function emitChange() {
  for (const listener of listeners) {
    listener();
  }
}

export const sessionStore = {
  subscribe(listener: () => void) {
    listeners = [...listeners, listener];
    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  },
  getSnapshot(): SessionData {
    return sessionData;
  },
  getServerSnapshot(): SessionData {
    return defaultSessionData;
  },
};

export function setSession(s: SessionData) {
  sessionData = s;
  emitChange();
}
